<template>
   <div class="row-item "  >
      <p @click="showEvents()">{{artist.artist_name}}</p>
      <transition name="slide">
         <div v-show="expand">
            <!-- <v-text-field
               label="http://detailseu.s3.amazonaws.com/rss/events_confirmed_berlin3.rss"
               single-line
               outlined>
            </v-text-field> -->
                <TextField
            class="m1"
            :id="'partnerLink'"
            
            :value="link"
        ></TextField>
            <v-card
               class="mx-auto"
               max-width="344"
               >
               <v-card-title class="card-headline">
                  {{artist.artist_name}} {{ $t('events_string') }}
               </v-card-title>
               <v-card-actions>
                  <template v-if="rssItems">
                        <template v-if="rssItems.rssItem.length>0">
                           <div class="rss-container">
                           <div   v-for="item in rssItems.rssItem" :key="item.artist_id">
                           
                                 <p>{{item.title}}</p>
                                 <p>{{item.description}}</p>
                            
                           </div>
                           </div>
                        </template>
                        <template v-else>
                           <div>
                              <p>{{ $t('no_events') }}</p>
                           </div>
                        </template>
                  </template>
                  
               </v-card-actions>
            
            </v-card>

         </div>
      </transition>
   </div>
</template>
<script>
   import { compose } from 'ramda'
   import * as ActionTypes from "../../store/types";
   import { mapGetters } from "vuex";
   import { SettingsStoreNamespace as storeNS } from "../../store";
   
   export default {
      props:["artist"],
      data:function(){
          return{
              expand:false,
              link:"http://detailseu.s3.amazonaws.com/rss/events_confirmed_berlin3.rss",
             // rssItems:[{title:"Carlita in Berlin - 27 November to 29 November",description:"Carlita, A-Lounge Berlin, Berlin, Germany, 2019-11-27"},{title:"Carlita in Berlin - 27 November to 29 November",description:"Carlita, A-Lounge Berlin, Berlin, Germany, 2019-11-27"}]
          }
       } ,
       computed: {
         ...mapGetters(storeNS, {
            rssData: "rssData"
         }),

         rssItems(){
            return this.rssData.filter(s=>s.artistId==this.artist.artist_id)[0]
         }
   
   },
       methods:{
         showEvents(){
           // this[ActionTypes.RssData.FETCH.SINGLE](this.artist.artist_id);
            this.$emit("getrssdata",this.artist.artist_id)
       
            this.expand = !this.expand
         }
       }
   //    computed: {
   //         ...mapGetters( {
   //             account: "account"
   //         })  
   //     }
   }
</script>
<style scoped>
   .rss-container
   {
      display: flex;
      flex-direction: row;
   }
   .row-item
   {
   border-bottom:1px solid #ccc;
   cursor: pointer;
   }
   .card-headline
   {
   background-color:rgb(144, 168, 179);
   color: white;
   padding: 10px
   }
   .row-item p
   {
   margin-bottom: 0px;
   }
   .slide-enter-active,
   .slide-leave-active {
   transition: all 0.3s;
   }
   .slide-enter,
   .slide-leave-to {
   opacity: 0;
   transform: translateY(-20px);
   }
</style>